module.exports = __webpack_public_path__ + "img/application-setting.b1c4c098.svg";